import { ref } from 'vue'
import { useFetch } from '@vueuse/core'

export const useCheckSpam = () => {
  const auth = ref('IYYZZ4ULOnC5C2XvHoR8BWXHFx0XPznjnSDGkFkdYydTingyA2zewdoPJT8c3nth')
  const responseLang = ref('de')

  const checkSpam = async (formData) => {
    const checkData = {
      'responseLang': responseLang.value ?? 'en',
      ...formData
    }
    const { data, error } = await useFetch('https://automation.autherith-media.eu/webhook/check-natural-language', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-spam-check': `${auth.value}`
      },
      body: JSON.stringify(checkData)
    }).json()

    if (error.value) {
      return {
        'status': 'error',
        'message': error.value
      }
    }
    return data.value
  }

  return {
    checkSpam,
    useCheckSpam
  }
}

